import React, {useContext, useState} from 'react';
import './Register.scss';
import AuthContext from "../../Store/auth-context";
import {useToasts} from 'react-toast-notifications';

// Icons //
import {IconContext} from "react-icons"
import {MdEmail} from "react-icons/md"
import {MdLock} from "react-icons/md"
import {FaUser} from "react-icons/fa"

const Email = () => {
    return (
        <IconContext.Provider
            value={{style: {fontSize: '18px', color: "rgba(0, 0, 0)"}}}><MdEmail/></IconContext.Provider>
    )
}

const Lock = () => {
    return (
        <IconContext.Provider
            value={{style: {fontSize: '18px', color: "rgba(0, 0, 0)"}}}><MdLock/></IconContext.Provider>
    )
}

const User = () => {
    return (
        <IconContext.Provider
            value={{style: {fontSize: '18px', color: "rgba(0, 0, 0)"}}}><FaUser/></IconContext.Provider>
    )
}

function Register() {
    const [username, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPass] = useState('');
    const {setRoleStatus, register, setToken} = useContext(AuthContext);
    const {addToast} = useToasts();
    const FormRigister = async (e) => {
        e.preventDefault();
        const reqBody = {
            username: username,
            email: email,
            password: password,
        }
        await register(reqBody)
            .then(response => {
                let token =response.data.jwt;
                setToken(token);
                setRoleStatus(false);
                setEmail(response.data.user.email);
                localStorage.setItem("email",response.data.user.email);
                localStorage.setItem("isActive", `${response.data.user.isActive}`)
                addToast('Successfully created an account',
                    {
                        appearance: 'success',
                        autoDismiss: 'true'
                    }
                );
            })
            .catch(error => {
                // Handle error.
                addToast(`${error.response.data.error.message}`, {appearance: 'error'});
            });
    }
    return (
        <div id='register'>
            <div className='loginBackground'>
                <div className='loginField'>
                    <h1>Create an Account</h1>
                    <h2>Simply signup below to get the capncovers best picks to build your bankroll!</h2>
                    <form onSubmit={FormRigister}>
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1"><FaUser/></span>
                            <input type="username" className="form-control" id="InputUsername"
                                   aria-describedby="username" placeholder='Username' value={username}
                                   onChange={(e) => setUser(e.target.value)}/>
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1"><Email/></span>
                            <input type="email" className="form-control" id="InputEmail" aria-describedby="email"
                                   placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)}/>
                        </div>
                        <div className="input-group mb-3">
                            <span className="input-group-text" id="basic-addon1"><Lock/></span>
                            <input type="password" className="form-control" id="InputPassword" placeholder='Password'
                                   value={password} onChange={(e) => setPass(e.target.value)}/>
                        </div>
                        <button type="submit" className="btn loginButton">Create an Account</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Register
